export default __webpack_public_path__ + "activate-icon.10d435d7b72f7e83ae278f439ed0b78d.svg";